import './App.css';
import { Layout, ConfigProvider } from 'antd';
import { useState } from 'react';
import Sidebar from './jsx/layout/SideBar';
import FooterBar from './jsx/layout/FooterBar';
import AppRoutes from './jsx/layout/nav/AppRoutes';
import { setNavigator } from './navigation';
import { useNavigate } from 'react-router-dom';
import { NotifyInitializer, NotifyProvider } from './jsx/customs/NotifyProvider';
import LoginPage from './jsx/Page/LoginPage';



const { Header, Footer, Sider, Content } = Layout;

function App() {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const userKey = localStorage.getItem('hc-admin-key');



  const navigate = useNavigate();
  setNavigator(navigate);

  if (!userKey) {
    return <LoginPage />;
  }

  return (
    <NotifyProvider>
      <NotifyInitializer />

      <ConfigProvider componentSize="large">
        <Layout style={{ minHeight: '100vh', overflow: 'hidden' }}>

          <Sider
            width={250}
            collapsedWidth={isMobile ? 0 : 80}
            collapsed={collapsed}
            onCollapse={(collapsed) => setCollapsed(collapsed)}
            style={{
              background: '#e0e0e0',
              overflow: 'auto',
              height: '100vh',
              position: 'fixed',
              left: 0,
              top: 0,
              zIndex: 100,
            }}
          >
            <Sidebar
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              isMobile={isMobile}
              setIsMobile={setIsMobile}
            />
          </Sider>

          <Layout
            style={{
              marginLeft: collapsed ? (isMobile ? 0 : 80) : 250,
              transition: 'margin-left 0.2s',
            }}
          >

            <Content
              style={{
                margin: '10px',
                padding: '5px',
                lineHeight: '0',
                borderRadius: 8,
                height: 'calc(100vh - 28px)',
                overflow: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
            >
              <style>{`::-webkit-scrollbar { display: none; }`}</style>
              <AppRoutes />
            </Content>

            <Footer
              style={{
                textAlign: 'center',
                padding: '0',
                margin: '0',
                lineHeight: '0',
              }}
            >
              <div style={{ height: '100%' }}>
                <FooterBar />
              </div>
            </Footer>
          </Layout>
        </Layout>
      </ConfigProvider>
    </NotifyProvider>
  );
}

export default App;
